import TipContext from '../TipContextComponents/TipContext';
/**后面确认此文件没有被引入了再删掉 */
export default TipContext;
